<template>
  <div class="container">
    <img
      src="../../assets/img/e_pic_register3.png"
      alt
      class="state-img"
    />
    <div v-if="$route.params.code == 0">
      <img
        src="../../assets/img/succese.png"
        alt
        class="icon-img"
      />
      <div class="state">绑定成功</div>
      <van-button
        class="btn"
        text="我知道了"
        block
        @click="gotofinance(1)"
      />
    </div>
    <div
      style="position:relative"
      v-else
    >
      <img
        src="../../assets/img/fail.png"
        alt
        class="icon-img"
      />
      <div class="state">绑定失败</div>
      <div class="loser">绑定失败原因：{{$route.params.message}}</div>
      <van-button
        class="btn"
        text="重新绑定"
        block
        @click="gotofinance(2)"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isBack: true // 跳转方式 如果是按钮跳转为false 右上角返回键跳转为true
    };
  },
  methods: {
    gotofinance(state) {
      this.isBack = false;
      if (state == 1) {
        this.$router.push("/e_bankCard");
      } else if (state == 2) {
        this.$router.push({
          name: "e_register",
          path: "/e_register",
          params: {
            message: this.$route.params.message,
          },
        });
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isBack) {
      this.isBack = false; // 防止重复跳转
      next("/e_bankCard");
    } else {
      next();
    }
  },
};
</script>
<style lang="scss" scoped>
.container {
  text-align: center;
}
.state-img {
  margin: 15px auto 20px;
  width: 310px;
  height: 55px;
}
.icon-img {
  width: 65px;
  height: 65px;
  margin: 62px auto 0;
  display: block;
}
.state {
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
}
.btn {
  width: 343px;
  height: 40px;
  margin: 60px 16px 0;
  font-size: 17px;
  color: #ffffff;
  background-color: #FFB14A;
  border-radius: 50px;
}
.loser {
  width: 271px;
  font-size: 14px;
  color: #333333;
  position: absolute;
  top: 176px;
  left: 50%;
  transform: translateX(-50%);
}
</style>